import { useMutation, useQuery } from '@apollo/client'
import { GET_INFOS } from '../graphql/query'
import { useEffect, useState } from 'react'
import { RiCloseLine } from 'react-icons/ri'
import { UPDATE_INFO } from '../graphql/mutation'

export default function Questions() {
    const [modal, setModal] = useState("")
    const { data, loading } = useQuery(GET_INFOS)

    if (loading) {
        return (
            <div className='Loading'>
                Loading...
            </div>
        )
    }
    return (
        <>
            <div className='Template'>
                <h2 style={{ marginTop: 20, marginLeft: 20, textAlign: "left", width: 600 }}>Questions</h2>
                <table className='Template_Table'>
                    <thead>
                        <tr>
                            <th>Question</th>
                            <th>EN Info</th>
                            <th>ES Info</th>
                            <th>FR Info</th>
                            <th>PT Info</th>
                            <th>RU Info</th>
                            <th>AR Info</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.getInfos?.slice()?.sort((a, b)=> a?.sortKey - b?.sortKey)?.map((item, index) => {
                            return (
                                <tr onClick={() => setModal(item)} style={{ userSelect: "none", cursor: "pointer" }} key={index}>
                                    <td>{item?.enQuestion}</td>
                                    <td>{item?.enInfo || "--"}</td>
                                    <td>{item?.esInfo || "--"}</td>
                                    <td>{item?.frInfo || "--"}</td>
                                    <td>{item?.ptInfo || "--"}</td>
                                    <td>{item?.ruInfo || "--"}</td>
                                    <td>{item?.arInfo || "--"}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
            <div className={modal ? 'UserModal UserModalOpen' : 'UserModal'}>
                <EditModal open={modal} setOpen={setModal} />
            </div>
        </>
    )
}

function EditModal({ setOpen, open }) {
    const [info, setInfo] = useState({})
    const [onCreate, { loading }] = useMutation(UPDATE_INFO, {
        refetchQueries: [
            { query: GET_INFOS }
        ]
    })

    useEffect(() => {
        setInfo({
            id: open?.id,
            sortKey: open?.sortKey,
            questId: open?.questId,
            enInfo: open?.enInfo,
            esInfo: open?.esInfo,
            ptInfo: open?.ptInfo,
            ruInfo: open?.ruInfo,
            frInfo: open?.frInfo,
            arInfo: open?.arInfo,
            enQuestion: open?.enQuestion,
            esQuestion: open?.esQuestion,
            ptQuestion: open?.ptQuestion,
            ruQuestion: open?.ruQuestion,
            frQuestion: open?.frQuestion,
            arQuestion: open?.arQuestion,
        })
    }, [open])

    const update = (id, val) => {
        setInfo(prev => {
            return {
                ...prev,
                [id]: val
            }
        })
    }
    

    return (
        <div className='UserModalCon'>
            <div className='UserModalHead'>
                Edit Info
                <RiCloseLine className='UserModalClose' size={18} onClick={() => setOpen(false)} />
            </div>
            <div className='UserModalCon1' style={{ marginRight: 15 }}>
                <div>
                    <h2>Question</h2>
                    <input disabled style={{ width: 450 }} value={open?.enQuestion} onChange={(e) => {
                        update("enQuestion", e?.target?.value)
                    }} placeholder='' />
                </div>
            </div>
            <div className='UserModalCon1' style={{ marginRight: 15 }}>
                <div>
                    <h2>EN Info</h2>
                    <input style={{ width: 450 }} value={info?.enInfo} onChange={(e) => {
                        update("enInfo", e?.target?.value)
                    }} placeholder='' />
                </div>
            </div>
            <div className='UserModalCon1' style={{ marginRight: 15 }}>
                <div>
                    <h2>ES Info</h2>
                    <input style={{ width: 450 }} value={info?.esInfo} onChange={(e) => {
                        update("esInfo", e?.target?.value)
                    }} placeholder='' />
                </div>
            </div>
            <div className='UserModalCon1' style={{ marginRight: 15 }}>
                <div>
                    <h2>FR Info</h2>
                    <input style={{ width: 450 }} value={info?.frInfo} onChange={(e) => {
                        update("frInfo", e?.target?.value)
                    }} placeholder='' />
                </div>
            </div>
            <div className='UserModalCon1' style={{ marginRight: 15 }}>
                <div>
                    <h2>PT Info</h2>
                    <input style={{ width: 450 }} value={info?.ptInfo} onChange={(e) => {
                        update("ptInfo", e?.target?.value)
                    }} placeholder='' />
                </div>
            </div>
            <div className='UserModalCon1' style={{ marginRight: 15 }}>
                <div>
                    <h2>RU Info</h2>
                    <input style={{ width: 450 }} value={info?.ruInfo} onChange={(e) => {
                        update("ruInfo", e?.target?.value)
                    }} placeholder='' />
                </div>
            </div>
            <div className='UserModalCon1' style={{ marginRight: 15 }}>
                <div>
                    <h2>AR Info</h2>
                    <input style={{ width: 450 }} value={info?.arInfo} onChange={(e) => {
                        update("arInfo", e?.target?.value)
                    }} placeholder='' />
                </div>
            </div>
            <div className='UserModalCon4'>
                <div className='FlexCon' />
                <button onClick={() => {
                    onCreate({
                        variables: {
                            "info": info
                        }
                    }).then(() => {
                        setOpen(false)
                    }).catch((err) => {
                        alert(err?.message)
                    })
                }}>{loading ? "Loading" : "Update"}</button>
            </div>
        </div>
    )
}